module.exports = __webpack_public_path__ + "static/media/pk.8c402ecf.svg";